import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/auth/_redux/authRedux";

import { clientesSlice } from "../app/_redux/clientes/clientesSlice";
import { usuariosSlice } from "../app/_redux/usuarios/usuariosSlice";
import { simulacoesFaturasSlice } from "../app/_redux/simulacoesFaturas/simulacoesFaturasSlice";
import { gestaoSCDESSlice } from "../app/_redux/gestaoSCDE/gestaoSCDESSlice";
import { balancoEnergeticoSlice } from "../app/_redux/balancoEnergetico/balancoEnergeticoSlice";
import { dashboardConsorcioSlice } from "../app/_redux/dashboardConsorcio/dashboardConsorcioSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  clientes: clientesSlice.reducer,
  usuarios: usuariosSlice.reducer,
  simulacoesFaturas: simulacoesFaturasSlice.reducer,
  gestaoSCDES: gestaoSCDESSlice.reducer,
  balancoEnergetico: balancoEnergeticoSlice.reducer,
  dashboardConsorcio: dashboardConsorcioSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
